module.exports = __webpack_public_path__ + "img/938C8D_403731_CECED8_554C4C-256px.b7e4705b.png";